export default "__VITE_ASSET__DtjOmVM$__"